import styled from 'styled-components';

import { tokens } from './MainDisconnect.tokens';

export const ActionsSection = styled.div`
    display: grid;
    justify-items: center;
    gap: ${tokens.gap}px;
    margin-top: ${tokens.marginTop.mobile}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: ${tokens.marginTop.desktop}px;
    }
`;
